// Plain (non-React) localStorage helper for IAM tokens. Kept out of React so
// api/l1.ts -- a bare axios config file imported very early -- can use it
// without pulling in React.

const ACCESS_TOKEN_KEY = 'iam_access_token';
const ID_TOKEN_KEY = 'iam_id_token';
const REFRESH_TOKEN_KEY = 'iam_refresh_token';
const AUTH_SOURCE_KEY = 'iam_auth_source';
const TENANT_NAME_KEY = 'iam_tenant_name';

export interface TokenEnvelope {
  AccessToken: string;
  IdToken?: string;
  RefreshToken?: string;
  ExpiresIn?: number;
  TokenType?: string;
}

export type AuthSource = 'local' | 'ciam';

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getIdToken(): string | null {
  return localStorage.getItem(ID_TOKEN_KEY);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function getAuthSource(): AuthSource | null {
  return localStorage.getItem(AUTH_SOURCE_KEY) as AuthSource | null;
}

export function getTenantName(): string | null {
  return localStorage.getItem(TENANT_NAME_KEY);
}

export function setTokens(envelope: TokenEnvelope, meta?: { authSource?: AuthSource; tenantName?: string }): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, envelope.AccessToken);
  if (envelope.IdToken) localStorage.setItem(ID_TOKEN_KEY, envelope.IdToken);
  if (envelope.RefreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, envelope.RefreshToken);
  if (meta?.authSource) localStorage.setItem(AUTH_SOURCE_KEY, meta.authSource);
  if (meta?.tenantName) localStorage.setItem(TENANT_NAME_KEY, meta.tenantName);
}

export function setAccessToken(accessToken: string): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

export function clearTokens(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(ID_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(AUTH_SOURCE_KEY);
  localStorage.removeItem(TENANT_NAME_KEY);
}
